export default {
    "Testimonials.index.249707-0": "Numerous satisfied customers",
    "Testimonials.index.249707-1": "Both the headquarters of the group and its subsidiaries have set up dedicated telephone service lines. The headquarters and third parties conduct regular or unspecified follow-up visits to users through dedicated telephone lines, supervise the quality of service personnel's work, and promise to respond and resolve complaints about service quality issues within 2 hours.",
    "Testimonials.index.249707-2": "San Francisco",
    "Testimonials.index.249707-3": "London",
    "Testimonials.index.249707-4": "Berlin",
    "Testimonials.index.249707-5": "Paris"
}